const itemsBase = [
  { name: 'Recorrido de un vehículo - Reporte por Tiempo', value: 1 },
  { name: 'Reporte por Punto', value: 2 },
  { name: 'Excesos de velocidad - Reporte por Tiempo', value: 3 },
  { name: 'Excesos de velocidad - Reporte por Vehículo', value: 4 },
  { name: 'Alertas salidas geocercas - Reporte por Tiempo', value: 7 },
  { name: 'Alertas salidas geocercas - Reporte por Vehículo', value: 8 },
  { name: 'Alertas ingreso a geocercas - Reporte por Tiempo', value: 14 },
  { name: 'Alertas ingreso a geocercas - Reporte por Vehículo', value: 15 },
  { name: 'Alertas movimiento sin autorización - Reporte por Tiempo', value: 9 },
  { name: 'Alertas movimiento sin autorización - Reporte por Vehículo', value: 10 }
]

const items = [
  ...itemsBase,
  { name: 'Alertas estacionarias (minuta de servicio) - Reporte por Tiempo', value: 11 },
  { name: 'Alertas estacionarias (minuta de servicio) - Reporte por Vehículo', value: 12 }
]

const itemsTestEng = [
  ...items,
  { name: 'Último evento recibido - Reporte por Grupo/Agencia', value: 5 },
  { name: 'Reporte condición actual vehículos', value: 6 },
  { name: 'Reporte historial de acciones', value: 13 }
]

const itemsTestGO = [
  ...itemsTestEng
]

export {
  itemsBase,
  items,
  itemsTestEng,
  itemsTestGO
}



// WEBPACK FOOTER //
// ./src/utils/reportsList.js